import { bindCard, authorizePay, queryTradeRecord } from "@/api/pay.js"

function _getParamsStr(payUrl) {
  let str = ""
  if (payUrl && payUrl.includes("?")) {
    str = payUrl.split("?")[1]
  }
  return str
}

export default {
  data() {
    return {
      tradeNo: "",
      signNum: "",
      payUrl: ""
    }
  },
  methods: {
    async bindCard() {
      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      try {
        const { data: res } = await bindCard({
          params: JSON.stringify({
            payWay: 901
          })
        })
        this.tradeNo = res.tradeNo
        this.signNum = res.signNum
        this.authorizePay(res.tradeNo)
      } catch (error) {
        console.log(error)
      } finally {
        loading.close()
      }
    },
    async authorizePay(tradeNo) {
      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      try {
        const { data: res } = await authorizePay({
          params: JSON.stringify({
            tradeNo,
            isSaveCardNo: 1
          })
        })
        if (res.paymentStatus == "20001") {
          localStorage.setItem("pay_redirect_url", location.href)
          location.href = location.origin + "/o2opay.html?" + _getParamsStr(res.payUrl)
        }
      } catch (error) {
        console.log(error)
      } finally {
        loading.close()
      }
    }
  }
}
